import { Component, OnInit, Input } from '@angular/core';
import { CurrentSlideService } from '../../_services/current-slide.service';
import { SectionsService } from '../../_services/sections.service';

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Component({
	selector: 'nav-progress',
	templateUrl: './nav-progress.component.html',
	styleUrls: ['./nav-progress.component.scss'],
	host: {'class': 'nav-progress'}
})
export class NavProgressComponent implements OnInit {
	private unsubscribe$ = new Subject<void>();
	activeProgress: number;
	//currentSlide: number;
	currentSlide: number;
	transitionDurationSlide;
	public isSliding: string ='';
	public paused: boolean = false;
	public autoplay: boolean;
	public autoplayClass: boolean;
	public isFast: boolean = false;
	public isHidden: boolean = false;
	public isInit: boolean = false;
	public timeout: number;

	public slides:any = [{id:0}];
	//@Input() slides;
	
	constructor(private _currentSlideService: CurrentSlideService, private _sectionsService: SectionsService) { }

	ngOnInit() {
		//this.autoplay = this._currentSlideService.getAutoplay();
		


		this.slides = this._currentSlideService.getSlides();

		/*this._currentSlideService.changeSlides.subscribe(slides => {
			setTimeout(() => {
				this.slides = slides;
			}, 500)
		});*/

		this.timeout = 1000;
		this._currentSlideService.autoplay
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {
			this.autoplay = data;
			this.autoplayClass = this.autoplay;
		});

		let isAutoplay = this.autoplay;
		if(isAutoplay){
			this._currentSlideService.setAutoplay(false);
		}
		this.hideNav();
		this.currentSlide = 0;
		if(this.isInit){
			this.timeout = 4000;
		}
		this.isInit = false;


		setTimeout(() => {
			this.showNav();
			if(isAutoplay){
				this._currentSlideService.setAutoplay(true);
			}
			this.isInit = true;
			this.animToSlide(this.currentSlide);
		}, 0)

		//this.onStart();//remove is used in the main file
		/*this._sectionsService.changeSection.subscribe(year => {
			let isAutoplay = this.autoplay;
			if(isAutoplay){
				this._currentSlideService.setAutoplay(false);
			}
			this.hideNav();
			this.currentSlide = 0;
			if(this.isInit){
				this.timeout = 4000;
			}
			this.isInit = false;


			setTimeout(() => {
				this.showNav();
				if(isAutoplay){
					this._currentSlideService.setAutoplay(true);
				}
				this.isInit = true;
				this.animToSlide(this.currentSlide);
			}, this.timeout)
		});*/

		this._currentSlideService.currentSlide
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {

			this.animToSlide(data);
			if(this.isInit){
				//this.currentSlide = data;
				//this.animToSlide(data);
			}
		});
		
	}

	ngAfterViewInit(){
		var element = document.querySelector('.nav-progress-step__line__completion');
		this.transitionDurationSlide = parseFloat(getComputedStyle(element)['transitionDuration']) * 1000;


	}
	onStart(){
		
	}


	goSlide(newCurrent: number){
		let time = Math.abs(newCurrent - this.currentSlide);
		if(time > 1){
			time = time + 1;
			this.isFast = true;
			setTimeout(() => {
				this.isFast = false;
			}, 70 * (time) )
		}
		this._currentSlideService.setCurrenSlide(newCurrent);
	}

	animToSlide(newCurrent: number){
		if(newCurrent != this.currentSlide){	
			if(newCurrent > this.currentSlide){
				this.isSliding = 'right';
				var time = [];
				let count = 0;
				for (var i = 0 ; i <= newCurrent - this.currentSlide; i++) {
					time.push(''+i);
				}
				for (var i = this.currentSlide ; i <= newCurrent; i++) {
					this.setTimeoutToSection(i,time[count],newCurrent);
					count++;
				}
			}
			else if(newCurrent < this.currentSlide){
				this.isSliding = 'left';
				var timeReverse = [];
				let count = this.currentSlide - newCurrent;
				for (var i = this.currentSlide - newCurrent ; i > 0; i--) {
					timeReverse.push(''+i);
				}

				for (var i = this.currentSlide ; i >= newCurrent; i--) {
					this.setTimeoutToSection(i,timeReverse[count],newCurrent);
					count--;
				}
			}
		}
	}
	setTimeoutToSection(newCurrentSection, time, last){
		//this function: to have a sweet animation for the bar when going to another section
		//(bar completing one after the other and not together)

		let speed = this.transitionDurationSlide;
		let speed2 = this.transitionDurationSlide;
		if(this.isFast){
			speed = 70;
			speed2 = 70;
		}
		setTimeout(() => {
			this.currentSlide = newCurrentSection;
			if(newCurrentSection == last){
				this.isSliding = 'active-start';
				setTimeout(() => {
					this.isSliding = '';
				}, speed2)
			}
		}, time*speed);
	}

	playPause(){
		if(this.autoplay){
			this._currentSlideService.setAutoplay(false);
		}
		else{
			this._currentSlideService.setAutoplay(true);
		}
		this.autoplayClass = this.autoplay;
	}

	hideNav(){
		this.isHidden = true;
	}
	showNav(){
		this.isHidden = false;
	}
	
	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}  
}
